import { EventEmitter } from '@angular/core';

export class StatefulCSS {
  private machine?: HTMLElement;
  private prefix: string;
  private states: Array<string>;
  private currentState: string;
  public stateChange = new EventEmitter<string>();

  constructor(states: Array<string> = [],
    machine: HTMLElement | null = null,
    prefix: string = 'state',
    initialState: string = ''
  ) {
    this.states = states;
    if (machine) this.machine = machine;
    this.prefix = prefix;
    this.SetPrefix(this.prefix);
    this.currentState = initialState;
  }

  SetPrefix(prefix: string): StatefulCSS {
    this.prefix = prefix;
    if (this.prefix !== '') {
      if (this.prefix.substr(-1, 1) !== '-') {
        this.prefix = this.prefix + '-';
      }
      if (this.prefix === '-') {
        this.prefix = '';
      }
    }
    return this;
  }

  SetMachine(element: HTMLElement): StatefulCSS {
    this.machine = element;
    return this;
  }

  AddState(state: string): StatefulCSS {
    this.states.push(state);
    return this;

  }

  SetState(state: string) {

    this.ToggleMachineState(false);
    if (this.states.indexOf(state) > -1) {
      this.currentState = this.prefix + state;
    }
    this.ToggleMachineState(true);
  }
  GetCurrentState(): string {
    if (this.currentState === '') { return ''; }
    return this.currentState.substr(this.prefix.length);
  }
  IsState(state: string) {
    return this.GetCurrentState() === state;
  }
  ToggleMachineState(optOnOff: boolean | null) {
    if (!this.machine || (this.currentState === '')) return;

    if (optOnOff === null) {
      this.machine.classList.toggle(this.currentState);
    } else {
      this.machine.classList.toggle(this.currentState, optOnOff);
    }
    this.stateChange.emit(this.GetCurrentState());
  }

}
